module.exports = __webpack_public_path__ + "static/media/ic_patner_with_us.91565fd7.svg";